import {
  TableColumnItem,
  TableColumnItemSort,
  TableColumnSortDirection,
  TableColumnTypeEnum,
} from '@ui-lib/components';

export const getHistoryTableColumnsConfig = (): TableColumnItem[] => [
  {
    propName: 'user',
    captionTranslateKey: 'monitoring.history.dashboard.column.user',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'action',
    captionTranslateKey: 'monitoring.history.dashboard.column.action',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'entityType',
    captionTranslateKey: 'monitoring.history.dashboard.column.entityType',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'details',
    captionTranslateKey: 'monitoring.history.dashboard.column.details',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'entityChangedDate',
    captionTranslateKey: 'monitoring.history.dashboard.column.entityChangedDate',
    type: TableColumnTypeEnum.Text,
    sort: new TableColumnItemSort(TableColumnSortDirection.desc),
  },
];
